import { BxgyDiscountCalculator } from './BxgyDiscountCalculator';
import { FixedAmountDiscountCalculator } from './FixedAmountDiscountCalculator';
import { PercentageDiscountCalculator } from './PercentageDiscountCalculator';
import type {
  Discount,
  DiscountBxgy,
  DiscountFixedAmount,
  DiscountPercentage,
} from '@/modules/store/models/Discount';
import type { CalculatedPrice, Price } from '@/modules/store/models/Price';

export interface DiscountCalculator<T extends Discount> {
  isApplicable(quantity: number, discount: T): boolean;

  calculate(originalPrice: Price, quantity: number, discount: T): CalculatedPrice | undefined;
}

export class DiscountCalculatorFactory {
  static create(discount: Discount): DiscountCalculator<Discount> {
    switch (discount.discountType) {
      case 'fixedAmount':
        return new FixedAmountDiscountCalculator() as DiscountCalculator<DiscountFixedAmount>;
      case 'percentage':
        return new PercentageDiscountCalculator() as DiscountCalculator<DiscountPercentage>;
      case 'bxgy':
        return new BxgyDiscountCalculator() as DiscountCalculator<DiscountBxgy>;
      default:
        throw new Error('Unsupported discount type');
    }
  }
}
